// extracted by mini-css-extract-plugin
export var createdDate = "_ny-1";
export var divider = "_ny-2";
export var headerDivider = "_ny-3";
export var messagesCard = "_ny-0";
export var messagesContainer = "_ny-6";
export var messagesContainerWrapper = "_ny-4";
export var showLeftPanelButton = "_ny-8";
export var topButtons = "_ny-7";
export var withPadding = "_ny-5";